<template>
  <div>
    <!-- создание / редактирование расписания пакета -->
    <el-dialog visible v-if="createScheduleFlag || editScheduleFlag" width="55%"
      :title="$t('scheduleForm.packageSchedule') + ': ' + selectedPacket.name" @close="cancelScheduleClick">
      <el-radio-group v-model="cronMode" class="cron-radio-container" @change="clearOthers()">
        <el-radio label="daily" class="cron-radio">
          <div class="test">
            <div class="radio-label">{{ $t("scheduleForm.daily") }}</div>
            <span>
              <div class="radio-label placeholder"></div>
              <el-time-picker v-model="dailyTime" :picker-options="{
                format: 'HH:mm',
              }" format="HH:mm" value-format="HH:mm" @focus="focus('daily')"></el-time-picker>
            </span>
          </div>
        </el-radio>
        <el-radio label="weekly" class="cron-radio">
          <div class="test">
            <div class="radio-label">{{ $t("scheduleForm.weekly") }}</div>
            <span>
              <el-select v-model="weekDay" :placeholder="$t('scheduleForm.dayOfWeek')" filterable
                @focus="focus('weekly')">
                <el-option v-for="(day, index) in weekDays" :key="index" :value="index + 1" :label="day"></el-option>
              </el-select>
              <el-time-picker v-model="weeklyTime" :picker-options="{
                format: 'HH:mm',
              }" format="HH:mm" value-format="HH:mm" @focus="focus('weekly')"></el-time-picker>
            </span>
          </div>
        </el-radio>
        <el-radio label="monthly" class="cron-radio">
          <div class="test">
            <div class="radio-label">{{ $t("scheduleForm.monthly") }}</div>
            <span style="display: flex">
              <div class="day-placeholder">
                {{ $t("scheduleForm.day") + ":" }}
              </div>
              <el-input-number v-model="dayOfMonth" :min="1" :max="31" :controls="false"
                @focus="focus('monthly')"></el-input-number>
              <el-time-picker v-model="monthlyTime" :picker-options="{
                format: 'HH:mm',
              }" format="HH:mm" value-format="HH:mm" @focus="focus('monthly')"></el-time-picker>
            </span>
          </div>
        </el-radio>
        <el-radio label="once" class="cron-radio">
          <div class="test">
            <div class="radio-label">{{ $t("scheduleForm.once") }}</div>
            <span>
              <el-date-picker v-model="onceDay" @focus="focus('once')" value-format="d M"
                format="dd-MMMM"></el-date-picker>
              <el-time-picker v-model="onceTime" :picker-options="{
                format: 'HH:mm',
              }" format="HH:mm" value-format="HH:mm" @focus="focus('once')"></el-time-picker>
            </span>
          </div>
        </el-radio>
        <el-radio label="special" class="cron-radio">
          <div class="test">
            <!-- <div class="radio-label">{{ $t("scheduleForm.special") }}</div> -->
            <div class="radio-label">{{ $t("scheduleForm.special") }}</div>
            <span>
              <el-input v-model="specialSchedule" @focus="focus('special')" @input="specialScheduleEntered(specialSchedule)"></el-input>
            </span>

          </div>
          <div class="test" style="cursor:auto">
            <!-- <div class="radio-label">{{ $t("scheduleForm.special") }}</div> -->
            <div class="radio-label"></div>
            <span style="margin: 0px 10px; color: #606266">{{ parsedExpression }}</span>

          </div>
        </el-radio>
      </el-radio-group>
      <el-checkbox v-model="cronDisabled">{{
        $t("scheduleForm.blockSchedule")
      }}</el-checkbox>
      <div slot="footer" class="bottom-buttons">
        <div></div>
        <div>
          <el-button class="button-cancel" type="plain" @click="cancelScheduleClick">{{ $t("scheduleForm.cancel")
          }}</el-button>
          <el-button class="button-confirm" type="success" @click="okScheduleClick">OK</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import cronstrue from "cronstrue/i18n";
export default {
  data() {
    return {
      cronDisabled: false,
      cronMode: null,
      dailyTime: null,
      weekDay: null,
      weeklyTime: null,
      weekDays: [
        this.$t("scheduleForm.monday"),
        this.$t("scheduleForm.tuesday"),
        this.$t("scheduleForm.wednesday"),
        this.$t("scheduleForm.thursday"),
        this.$t("scheduleForm.friday"),
        this.$t("scheduleForm.saturday"),
        this.$t("scheduleForm.sunday"),
      ],
      dayOfMonth: null,
      monthlyTime: null,
      onceDay: null,
      onceTime: null,
      specialSchedule: null,
      finalCronExp: null,
      parsedExpression: null
    };
  },
  methods: {
    focus(mode) {
      this.cronMode = mode;
      this.clearOthers();
    },
    toCronExp(time) {
      let hour;
      let min;
      let timeArray = time.split(":");
      let hourArray = timeArray[0].split("");
      if (hourArray[0] === "0") hour = hourArray[1];
      else hour = timeArray[0];
      let minArray = timeArray[1].split("");
      if (minArray[0] === "0") min = minArray[1];
      else min = timeArray[1];
      return min + " " + hour;
    },
    // SCHEDULE
    cancelScheduleClick() {
      this.cronDisabled = false;
      if (this.createScheduleFlag)
        this.$store.commit("setScheduleFlag", {
          field: "schedule",
          action: "create",
          value: false,
        });
      if (this.editScheduleFlag)
        this.$store.commit("setScheduleFlag", {
          action: "edit",
          value: false,
        });
    },
    okScheduleClick() {
      try {
        let time;
        let finalExpr;
        let minHour;
        if (this.cronMode === "daily") {
          if (!this.dailyTime) throw this.$t("scheduleForm.timeNotSelected");
          minHour = this.toCronExp(this.dailyTime);
          finalExpr = minHour + " * * *";
        } else if (this.cronMode === "weekly") {
          if (!this.weeklyTime) throw this.$t("scheduleForm.timeNotSelected");
          minHour = this.toCronExp(this.weeklyTime);
          if (!this.weekDay) throw this.$t("scheduleForm.dayOfWeekNotSelected");
          finalExpr = minHour + " * * " + this.weekDay;
        } else if (this.cronMode === "monthly") {
          if (!this.monthlyTime) throw this.$t("scheduleForm.timeNotSelected");
          minHour = this.toCronExp(this.monthlyTime);
          finalExpr = minHour + " " + this.dayOfMonth + " * *";
        } else if (this.cronMode === "once") {
          if (!this.onceDay) throw this.$t("scheduleForm.dateNotSelected");
          if (!this.onceTime) throw this.$t("scheduleForm.timeNotSelected");
          minHour = this.toCronExp(this.onceTime);
          finalExpr = minHour + " " + this.onceDay + " *";
        } else {
          if(!this.specialSchedule) throw this.$t("scheduleForm.specialExpressionNotSelected");
          finalExpr = this.specialSchedule;
        }
        const res = this.cronParse(finalExpr);
        if (res.includes("Error")){
          throw res;
        }
        if (this.createScheduleFlag) {
          this.$store
            .dispatch("addCronSchedule", {
              idPacket: this.selectedPacket.id,
              cronExp: finalExpr,
              disabled: this.cronDisabled,
            })
            .then(() => {
              this.$store.commit("setScheduleFlag", {
                action: "create",
                value: false,
              });
              this.cronDisabled = false;
              this.$store.commit("setPacket", null);
            })
            .catch(() => { });
        } else if (this.editScheduleFlag) {
          this.$store
            .dispatch("editCronSchedule", {
              id: this.selectedPacket.schedule[0].id,
              cronExp: finalExpr,
              disabled: this.cronDisabled,
            })
            .then(() => {
              this.$store.commit("setScheduleFlag", {
                action: "edit",
                value: false,
              });
              this.cronDisabled = false;
              this.$store.commit("setPacket", null);
            });
        }
      } catch (e) {
        this.$store.commit("setError", e);
      }
    },
    clearOthers() {
      const resetValues = {
        dailyTime: null,
        weekDay: null,
        weeklyTime: null,
        monthlyTime: null,
        dayOfMonth: null,
        onceDay: null,
        onceTime: null,
        specialSchedule: null,
        parsedExpression: null
      }
      if (this.cronMode === "daily") {
        delete resetValues.dailyTime;
      }
      else if (this.cronMode === "weekly") {
        delete resetValues.weekDay;
        delete resetValues.weeklyTime;
      }
      else if (this.cronMode === "monthly") {
        delete resetValues.dayOfMonth;
        delete resetValues.monthlyTime;
      }
      else if (this.cronMode === "once") {
        delete resetValues.onceDay;
        delete resetValues.onceTime;
      }
      else {
        delete resetValues.specialSchedule;
        delete resetValues.parsedExpression;
      }
      for (const key in resetValues) {
        if (this[key]) this[key] = resetValues[key];
      }
    },
    specialScheduleEntered(expression) {
      this.parsedExpression = this.cronParse(expression);
    },
    cronParse(expression) {
      try {
        let locale = this.language;
        if (this.language === "ua") locale = "uk";
        const parsedResult = cronstrue.toString(expression, { use24HourTimeFormat: true, locale });
        return parsedResult;
      }
      catch (err) {
        return err;
      }

    }
  },
  watch: {
    editScheduleFlag() {
      if (this.editScheduleFlag) {
        // this.cronExp = this.selectedPacket.schedule[0].cron_time;
        this.cronDisabled =
          this.selectedPacket.schedule[0].disable === "1" ? true : false;
        let exp = this.selectedPacket.schedule[0].cronExp;
        let array = exp.split(" ");
        let min, hour, day, month, weekDay;
        [min, hour, day, month, weekDay] = array;
        if (exp.includes(",") || exp.includes("-") || exp.includes("/") || !exp.includes("*") || weekDay !== "*" && month !== "*" || weekDay !== "*" && day !== "*") {
          this.cronMode = "special";
          this.specialSchedule = exp;
          return;
        }
        if (hour === "undefined") {
          hour = "0";
          min = "0";
        }
        if (hour.length === 1) hour = "0" + hour;
        if (min.length === 1) min = "0" + min;
        if (weekDay !== "*") {
          //еженедельное расписание
          this.cronMode = "weekly";
          this.weeklyTime = hour + ":" + min;
          this.weekDay = +weekDay;
        } else if (month !== "*") {
          //разовое расписание
          this.cronMode = "once";
          this.onceTime = hour + ":" + min;
          this.onceDay = day + " " + month;
        } else if (day !== "*") {
          //ежемесячное расписание
          this.cronMode = "monthly";
          this.monthlyTime = hour + ":" + min;
          this.dayOfMonth = day;
        } else {
          //ежедневное расписание
          this.cronMode = "daily";
          this.dailyTime = hour + ":" + min;
        }

      }
    },
  },
  computed: {
    ...mapGetters(["createScheduleFlag", "editScheduleFlag", "selectedPacket", "language"]),
  },
};
</script>

<style scoped>
.el-radio-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.el-radio.cron-radio {
  display: flex !important;
  flex-direction: row !important;
  width: 100%;
}

.test {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.radio-label {
  width: 150px;
  margin: auto 0px;
}

.radio-label.placeholder {
  margin: 5px 10px;
}

.el-radio .el-radio__input {
  margin-top: 12px !important;
}

.el-select,
.el-date-editor,
.el-input,
.el-input-number {
  width: 170px;
  margin: 5px 10px;
}

.el-input-number {
  width: calc(150px - 10px - 50px);
}

.day-placeholder {
  width: 50px;
  margin: auto 0px;
  margin-left: 10px;
  color: #606266;
}
</style>